var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70922 0.292898C1.3187 -0.0976327 0.685544 -0.0976327 0.295026 0.292898C-0.0954925 0.683429 -0.0954925 1.3166 0.295026 1.70713L8.08656 9.49892L0.292888 17.2928C-0.0976294 17.6834 -0.0976298 18.3165 0.292888 18.7071C0.683406 19.0976 1.31656 19.0976 1.70708 18.7071L9.50075 10.9132L17.2944 18.7071C17.6849 19.0976 18.3181 19.0976 18.7086 18.7071C19.0991 18.3166 19.0991 17.6834 18.7086 17.2928L10.9149 9.49892L18.7065 1.70713C19.097 1.3166 19.097 0.683429 18.7065 0.292898C18.316 -0.0976326 17.6828 -0.0976327 17.2923 0.292898L9.50075 8.08469L1.70922 0.292898Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.3c33b864d3cc4e170b4ce6696b34a600.svg";
export { ForwardRef as ReactComponent };